import { mapState, mapGetters, mapMutations } from 'vuex'

const TOAST_DURATION = 4000

export default {
  computed: {
    ...mapState('notify', ['messages']),
    ...mapGetters('notify', [ 'latestMessage'])
  },
  watch: {
    latestMessage: {
      handler(newVal, oldVal) {
        if (!newVal) return
        if (oldVal === newVal) return
        this.$nextTick(() => {
          this.showToast(newVal.text, newVal.type)
          setTimeout(() => {
            this.$store.commit('notify/removeLast')
          }, TOAST_DURATION)
        })
      },
      immediate: true
    },
  },
  methods: {
    ...mapMutations({ clearNotify: 'notify/clear' }),
    onFade() {
      
    },
    showToast(text, type){
      this.$bvToast.toast(text, {
        noCloseButton: true,
        autoHideDelay: TOAST_DURATION,
        toaster: 'b-toaster-bottom-center',
        solid: true,
        variant: type
      })
    }
  }
}